import { Permission, useFeatureFlag, usePermission } from '@bonusly/who-am-i';

import { Bonus, BonusPrivacy } from '../../../../../../types/bonus';
import { useContextualizedBonusDetails } from '../../../hooks/use-contextualized-bonus-details';
import { useSayThanks } from '../../../hooks/use-say-thanks';
import { Variant } from '../../../lib/experiment';

export const useActions = (bonus: Bonus) => {
	const hasOneOnOnesEarlyAccess = useFeatureFlag(Variant.OneOnOnesEarlyAccess);
	const hasOneOnOnesLimitedRelease = useFeatureFlag(Variant.OneOnOnesLimitedRelease);
	const hasOneOnOnesPackage = usePermission(Permission.CanAccessOneOnOnes);

	const displayThanks = useSayThanks(bonus);
	const { canUserAddOn, isUserReceiver, isUserReceiversManager, isGiverHuman, onlyOneReceiver } = useContextualizedBonusDetails(bonus);
	const hasLinkedFeedback = !!bonus.evaluations?.length;
	const isPublic = bonus.privacy === BonusPrivacy.Public;
	const isFeedbackCandidate = bonus.traits?.some((trait) => trait.name === 'feedback_candidate') ?? false;

	// TODO Remove once we confirm the biz logic is correct
	const showFeedbackButton = false;
	const displayFeedback =
		(hasOneOnOnesEarlyAccess || hasOneOnOnesPackage || hasOneOnOnesLimitedRelease) &&
		isGiverHuman &&
		(isUserReceiver || (isUserReceiversManager && onlyOneReceiver)) &&
		isPublic &&
		showFeedbackButton;

	const displayFeedbackPanel = displayFeedback && !hasLinkedFeedback && isPublic && isFeedbackCandidate;

	const displayAddOn = canUserAddOn;

	return {
		displayAddOn,
		displayFeedback,
		displayFeedbackPanel,
		displayThanks,
	};
};
